import { render, staticRenderFns } from "./ProductMoney.vue?vue&type=template&id=4416817e&scoped=true&"
import script from "./ProductMoney.vue?vue&type=script&lang=js&"
export * from "./ProductMoney.vue?vue&type=script&lang=js&"
import style0 from "./ProductMoney.vue?vue&type=style&index=0&id=4416817e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4416817e",
  null
  
)

export default component.exports